import { Text, Block } from 'slate';
import { removeNonPrintableCharacters } from './removeNonPrintableCharacters';

export default ({ editor, copiedFragment, pasteType }) => {
  const textNodesFragment = copiedFragment?.getTexts()?.toArray();

  editor.withoutNormalizing(() => {
    const {
      value: {
        selection: { isExpanded },
      },
    } = editor;

    if (isExpanded) editor.delete();
    const {
      value: {
        focusBlock,
        selection: {
          anchor: { offset },
        },
      },
    } = editor;

    const {
      key: focusBlockKey,
      type: focusBlockType,
      data: focusBlockData,
      nodes: focusBlockNodes,
    } = focusBlock;
    editor.splitNodeByKey(focusBlockNodes.toArray()[0].key, offset);

    const {
      value: { focusBlock: updatedFocusBlock1, document: updatedDocument },
    } = editor;
    let textNodesEditor;
    if (
      pasteType.includes('ORGANIZATION') ||
      pasteType === 'PERSONAL_LINK' ||
      pasteType === 'ARRAY_ITEM'
    )
      textNodesEditor = updatedFocusBlock1.getTexts().toArray();
    else textNodesEditor = updatedDocument.getTexts().toArray();

    // insert empty text nodes between textNodesFragment
    const copiedFragmentTextNodes = [];
    const emptyTextNode = Text.create({ text: ' ' });
    textNodesFragment?.forEach((textNode, index) => {
      let text = textNode?.text?.replace(/[\r\n]+/g, ' ')?.trim();
      text = removeNonPrintableCharacters(text);
      const cleanedTextNode = Text.create({
        ...textNode,
        text,
      });

      copiedFragmentTextNodes.push(cleanedTextNode);
      if (textNodesFragment && index !== textNodesFragment?.length - 1)
        copiedFragmentTextNodes.push(emptyTextNode);
    });

    const finalTextNodes = [
      textNodesEditor[0],
      ...copiedFragmentTextNodes,
      textNodesEditor[1],
    ];

    const blockProperties = {
      type: focusBlockType,
      data: { ...focusBlockData.toJSON() },
      nodes: [...finalTextNodes],
    };
    const updatedFocusBlock2 = Block.create(blockProperties);

    editor.replaceNodeByKey(focusBlockKey, updatedFocusBlock2);

    const finalTextNodesLength = finalTextNodes.length;
    finalTextNodes.forEach((textNode, index) => {
      const { key: textNodeKey } = textNode;
      if (index !== 0) editor.mergeNodeByKey(textNodeKey);
      if (finalTextNodesLength - 1 !== index)
        editor.moveToStartOfNode(finalTextNodes[index + 1]);
    });
  });
};
